export default __webpack_public_path__ + "static/media/device.c234c723.svg";